import React, { useState, useRef, useEffect } from 'react';
import { Button, Box, Chip } from '@mui/material';
import { Upload as UploadIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const FileUploadButton = ({ 
  onFileSelect, 
  accept = 'image/*',
  label = 'Upload File',
  currentFile = null,
  buttonProps = {},
  showPreview = true,
  name,
  disabled = false,
  previewUrl = null,
}) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const type = accept.split('/')[0];

  // Update preview when currentFile changes (for editing)
  useEffect(() => {
    if (currentFile) {
      setSelectedFile(currentFile);
      if (typeof currentFile === 'string') {
        setPreview(currentFile);
      } else if (currentFile instanceof File) {
        const previewUrl = URL.createObjectURL(currentFile);
        setPreview(previewUrl);
        return () => URL.revokeObjectURL(previewUrl);
      }
    }
  }, [currentFile]);

  useEffect(() => {
    if (previewUrl) {
      setPreview(previewUrl);
    }
  }, [previewUrl]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setSelectedFile(file);
    setPreview(previewUrl);

    // Call the onFileSelect callback with the file
    if (onFileSelect) {
      onFileSelect({name, file});
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleRemoveFile = (e) => {
    e.stopPropagation();
    setSelectedFile(null);
    setPreview(null);
    if (onFileSelect) {
      onFileSelect({name, file: null});
    }
  };

  return (
    <Box>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept={accept || ''}
      />
      <Button
        variant="contained"
        component="span"
        startIcon={<UploadIcon />}
        onClick={handleButtonClick}
        disabled={disabled}
        {...buttonProps}
      >
        {label}
      </Button>
      
      {showPreview && (selectedFile || preview) && (
        <Box sx={{ mt: 2 }}>
          <Chip 
            icon={<CheckCircleIcon />}
            label={selectedFile?.name || 'Selected file'}
            color="success"
            variant="outlined"
            onDelete={handleRemoveFile}
            sx={{ mb: 1 }}
          />
          {preview && (
            <Box sx={{ mt: 1 }}>
              {type === 'image' && (
              <img
                src={preview}
                alt="Preview"
                style={{
                  maxWidth: '100%',
                  maxHeight: '200px',
                  borderRadius: '4px',
                }}
              />
              )}
              {type === 'audio' && (
              <audio
                controls
                src={preview}
                style={{
                  maxWidth: '100%',
                  maxHeight: '200px',
                  borderRadius: '4px',
                  width: '100%',
                }}
              />
              )}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default FileUploadButton;
